import { Component, effect, input, signal } from '@angular/core';

@Component({
    selector: 'app-reports-view',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    standalone: false
})
export class ReportsComponent {
  readonly subHeader = signal('Notice');
  readonly chosenReportAction = signal<'Notice' | 'Term Consolidated Report' | 'Adhoc Report'>('Notice');
  readonly reportFeatures = input<string[]>([]);

  constructor() {
    effect(() => {
      const features = this.reportFeatures();
      if (!features.length) {
        return;
      }

      if (features.includes('overageDependentNotice')) {
        this.chosenReportAction.set('Notice');
        this.subHeader.set('Notice');
        return;
      }

      if (features.includes('customGroupReport')) {
        this.subHeader.set('customGroupReport');
      }
    });
  }

  toggle(event: string): void {
    this.subHeader.set(event);
  }

  changeForm(selectedODCategory: 'Notice' | 'Term Consolidated Report' | 'Adhoc Report'): void {
    this.chosenReportAction.set(selectedODCategory);
    this.subHeader.set(selectedODCategory);
  }
}
